type Props = {
  word: string;
  theme: "ink" | "bone";
};

export function MonumentType({ word, theme }: Props) {
  const color =
    theme === "bone" ? "rgba(5,5,5,0.035)" : "rgba(245,240,228,0.025)";
  return (
    <div
      aria-hidden="true"
      style={{
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        fontFamily: "var(--f-serif-display)",
        fontWeight: 900,
        fontStretch: "75%",
        fontSize: "clamp(12rem, 32vw, 48rem)",
        lineHeight: 0.75,
        letterSpacing: "-0.04em",
        color,
        textTransform: "uppercase",
        pointerEvents: "none",
        userSelect: "none",
        whiteSpace: "nowrap",
        zIndex: 0,
      }}
    >
      {word}
    </div>
  );
}
